import { render, staticRenderFns } from "./SameAddressList.vue?vue&type=template&id=c254797a&scoped=true"
import script from "./SameAddressList.vue?vue&type=script&lang=js"
export * from "./SameAddressList.vue?vue&type=script&lang=js"
import style0 from "./SameAddressList.vue?vue&type=style&index=0&id=c254797a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c254797a",
  null
  
)

export default component.exports